<script>
import moment from 'moment'
import appConfig from '@src/app.config'
import { crudMethods } from '@state/helpers'

export default {
  page: {
    title: 'Dashboard',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },

  components: {},

  data() {
    return {
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},

      progress: '',
      data: [],
      dataResult: [],

      rows: 1,
      perPage: 1,
      currentPage: 1,
      total: 1,
      from: 1,
      to: 1,

      modalTable: false,

      rStatus: '',
      rProgress: '',
      rBa: '',
      rBaSirkulir: '',
      rSitewitel: '',
      rTahun: '',

      fields: [],

      item: {},

      dataStacked: {
        chartOptions: {
          chart: {
            type: 'bar',
            height: 340,
            stacked: true,
            toolbar: {
              show: false,
            },
            zoom: {
              enabled: false,
            },
            fontFamily: 'inherit',
          },

          colors: ['#dc2626', '#94a3b8'],

          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '45%',
              borderRadius: 4,
              borderRadiusApplication: 'end',
            },
          },

          stroke: {
            width: 1,
            colors: ['#ffffff'],
          },

          dataLabels: {
            enabled: false,
          },

          grid: {
            borderColor: '#f1f5f9',
            strokeDashArray: 3,
            xaxis: {
              lines: {
                show: false,
              },
            },
            yaxis: {
              lines: {
                show: true,
              },
            },
          },

          xaxis: {
            categories: [],
            labels: {
              style: {
                colors: '#64748b',
                fontSize: '10px',
              },
            },
            axisBorder: {
              color: '#e2e8f0',
            },
            axisTicks: {
              color: '#e2e8f0',
            },
          },

          yaxis: {
            labels: {
              style: {
                colors: '#64748b',
                fontSize: '10px',
              },
              formatter: (value) => {
                return this.formatCompactCurrency(value)
              },
            },
          },

          legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            fontSize: '11px',
            fontWeight: 500,
            labels: {
              colors: '#64748b',
            },
            markers: {
              width: 8,
              height: 8,
              radius: 8,
            },
            itemMargin: {
              horizontal: 10,
              vertical: 4,
            },
          },

          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: (value) => {
                return this.formatCurrency(value)
              },
            },
          },

          fill: {
            opacity: 1,
          },

          responsive: [
            {
              breakpoint: 768,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  bar: {
                    columnWidth: '55%',
                  },
                },
                legend: {
                  position: 'bottom',
                },
              },
            },
          ],
        },

        series: [],
      },

      year: moment().format('YYYY'),
      years: [],
    }
  },

  mounted() {
    this.getData()

    for (let i = Number(this.year); i >= 2022; i--) {
      this.years.push(i)
    }
  },

  methods: {
    ...crudMethods,

    getData() {
      this.listData({
        url: `web/dashboard/stacked-outlook?year=${this.year}`,
      }).then((response) => {
        const { data } = response.data

        this.item = data || {}

        this.setStackedData(data || {})
      })
    },

    setStackedData(data) {
      this.dataStacked = {
        series: data.series || [],

        chartOptions: {
          ...this.dataStacked.chartOptions,

          xaxis: {
            ...this.dataStacked.chartOptions.xaxis,
            categories: data.categories || [],
          },
        },
      }
    },

    changeYear() {
      this.getData()
    },

    formatCompactCurrency(value) {
      const number = Math.abs(Number(value || 0))

      if (number >= 1.0e9) {
        return `Rp${(number / 1.0e9).toFixed(2)} M`
      }

      if (number >= 1.0e6) {
        return `Rp${(number / 1.0e6).toFixed(2)} Jt`
      }

      if (number >= 1.0e3) {
        return `Rp${(number / 1.0e3).toFixed(2)} Rb`
      }

      return `Rp${number.toLocaleString('id-ID')}`
    },

    formatCurrency(value) {
      return `Rp${Number(value || 0)
        .toFixed(0)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    },

    getSeriesValue(seriesIndex, index) {
      const series =
        this.item && this.item.series && this.item.series[seriesIndex]

      if (!series || !Array.isArray(series.data)) {
        return 0
      }

      return Number(series.data[index] || 0)
    },
  },
}
</script>

<template>
  <div class="revenue-outlook-widget">
    <div class="card dashboard-card">
      <!-- Header -->
      <div class="card-header dashboard-card-header">
        <div class="header-title-wrapper">
          <div class="header-icon">
            <feather type="bar-chart-2" size="17"></feather>
          </div>

          <div>
            <h5 class="header-title">
              Realisasi Tagihan
            </h5>

            <div class="header-subtitle">
              Perbandingan realisasi tagihan dengan plan berdasarkan bulan
            </div>
          </div>
        </div>

        <div class="header-action">
          <label for="realisasi-tagihan-year">
            Tahun
          </label>

          <b-form-select
            id="realisasi-tagihan-year"
            v-model="year"
            :options="years"
            size="sm"
            @change="changeYear"
          />
        </div>
      </div>

      <!-- Body -->
      <div class="card-body dashboard-card-body">
        <div class="row align-items-center">
          <!-- Table -->
          <div class="col-lg-5 table-column">
            <div
              v-if="
                item &&
                  item.categories &&
                  item.categories.length > 0 &&
                  item.series &&
                  item.series.length >= 2
              "
              class="table-wrapper"
            >
              <table class="table table-dashboard">
                <thead>
                  <tr>
                    <th class="text-left">
                      Bulan
                    </th>

                    <th class="text-right">
                      Realisasi Tagihan
                    </th>

                    <th class="text-right">
                      Plan
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(month, index) in item.categories" :key="index">
                    <td>
                      <div class="month-name">
                        <span class="month-dot"></span>
                        {{ month }}
                      </div>
                    </td>

                    <td class="text-right">
                      {{ formatCurrency(getSeriesValue(0, index)) }}
                    </td>

                    <td class="text-right plan-value">
                      {{ formatCurrency(getSeriesValue(1, index)) }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="empty-table">
              <feather type="bar-chart-2" size="28" />

              <span>
                Tidak ada data
              </span>
            </div>
          </div>

          <!-- Chart -->
          <div class="col-lg-7 chart-column">
            <div v-if="dataStacked.series.length > 0" class="chart-wrapper">
              <apexchart
                height="340"
                :series="dataStacked.series"
                :options="dataStacked.chartOptions"
              />
            </div>

            <div v-else class="empty-chart">
              <feather type="bar-chart-2" size="28" />

              <span>
                Tidak ada data
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.revenue-outlook-widget {
  width: 100%;
}

.dashboard-card {
  margin-bottom: 20px;
  overflow: hidden;
  border: 1px solid #edf0f3;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.03),
    0 8px 24px rgba(15, 23, 42, 0.04);
}

.dashboard-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  min-height: 64px;
  padding: 13px 18px;

  border-bottom: 1px solid #f1f5f9;
  background: #ffffff;
}

.header-title-wrapper {
  display: flex;
  align-items: center;
  min-width: 0;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 34px;
  height: 34px;

  margin-right: 11px;

  border-radius: 9px;

  color: #dc2626;
  background: #fef2f2;
}

.header-title {
  margin: 0;

  color: #1e293b;

  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
}

.header-subtitle {
  margin-top: 2px;

  color: #94a3b8;

  font-size: 10px;
  line-height: 1.3;
}

.header-action {
  display: flex;
  align-items: center;
  gap: 7px;

  flex-shrink: 0;

  label {
    margin: 0;

    color: #64748b;

    font-size: 11px;
    font-weight: 600;
  }

  .custom-select {
    width: 90px;
    min-height: 32px;

    padding-top: 4px;
    padding-bottom: 4px;

    border-color: #e2e8f0;
    border-radius: 7px;

    color: #475569;

    font-size: 11px;

    box-shadow: none;

    &:focus {
      border-color: #dc2626;

      box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.08);
    }
  }
}

.dashboard-card-body {
  padding: 14px 18px 16px;
}

.table-column {
  display: flex;
  align-items: center;
}

.table-wrapper {
  width: 100%;

  max-height: 340px;

  overflow-x: auto;
  overflow-y: auto;

  border: 1px solid #edf0f3;
  border-radius: 9px;

  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.table-dashboard {
  width: 100%;
  min-width: 400px;

  margin: 0;

  color: #475569;

  font-size: 11px;

  border-collapse: separate;
  border-spacing: 0;

  thead {
    position: sticky;
    top: 0;
    z-index: 2;

    th {
      padding: 9px 10px;

      border-top: 0;
      border-bottom: 1px solid #e2e8f0;

      background: #f8fafc;

      color: #64748b;

      font-size: 10px;
      font-weight: 700;

      white-space: nowrap;
    }
  }

  tbody {
    td {
      padding: 9px 10px;

      border-top: 1px solid #f1f5f9;

      vertical-align: middle;

      white-space: nowrap;
    }

    tr {
      transition: background 0.15s ease;

      &:hover {
        background: #fafafa;
      }
    }
  }
}

.month-name {
  display: flex;
  align-items: center;

  color: #334155;

  font-weight: 600;
}

.month-dot {
  width: 6px;
  height: 6px;

  margin-right: 7px;

  border-radius: 50%;

  background: #dc2626;
}

.plan-value {
  color: #64748b;
  font-weight: 600;
}

.chart-column {
  display: flex;
  align-items: center;
  justify-content: center;
}

.chart-wrapper {
  width: 100%;
}

.empty-chart,
.empty-table {
  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  width: 100%;

  height: 340px;

  color: #cbd5e1;

  font-size: 11px;

  svg {
    margin-bottom: 8px;
  }
}

.empty-table {
  height: 300px;
}

@media (max-width: 991.98px) {
  .table-column {
    margin-bottom: 12px;
  }

  .table-wrapper {
    max-height: 300px;
  }

  .chart-wrapper {
    width: 100%;
  }
}

@media (max-width: 575.98px) {
  .dashboard-card-header {
    align-items: flex-start;

    flex-direction: column;

    gap: 10px;
  }

  .header-action {
    width: 100%;

    justify-content: flex-end;
  }

  .dashboard-card-body {
    padding: 10px 12px 14px;
  }

  .table-dashboard {
    font-size: 10px;
  }

  .table-wrapper {
    max-height: 260px;
  }
}
</style>
